// extracted by mini-css-extract-plugin
export var activeDot = "_4f-c";
export var buttonContainer = "_4f-9";
export var channelButton = "_4f-a";
export var clickable = "_4f-d";
export var content = "_4f-0";
export var contentFull = "_4f-2";
export var contentThird = "_4f-1";
export var contentWrapper = "_4f-7";
export var description = "_4f-5";
export var heightShort = "_4f-f";
export var image = "_4f-3";
export var imageContainer = "_4f-4";
export var selectButton = "_4f-e";
export var spinnerContainer = "_4f-b";
export var titleContent = "_4f-8";
export var titleWrapper = "_4f-6";